var React = require('react');
import Tooltip from '../../Tooltip';
import tooltipDescriptions from '../../TooltipDescriptions';
const costMappings = JSON.parse(document.getElementById('cost-mappings').getAttribute('data_value'));

class ChemistryAccordion extends React.Component {

    constructor() {
        super();
        this.state = {
            open: false
        }
        this.onClick = this.onClick.bind(this);
        this.contents = this.contents.bind(this);
        this.checkboxClick = this.checkboxClick.bind(this);
        this.renderOption = this.renderOption.bind(this);
    }

    onClick(e) {
        this.props.actions.clickAccordion(this.props.index, e.target.checked)
        this.setState({open: !this.state.open})
    }

    checkboxClick(inputName, e) {
        this.props.actions.checkInput(this.props.index, inputName, e.target.checked)
    }

    renderOption(testId, displayName) {
        return (
            <div>
                <input
                    className="user-checkbox big-checkbox"
                    id={testId}
                    value={testId}
                    type="checkbox"
                    name={`option-${this.props.index}[]`}
                    onClick={(e) => {
                        this.checkboxClick(testId, e);
                    }}
                />
                <span className="option-label">
                    <Tooltip text={tooltipDescriptions[testId] || displayName}>
                        {displayName} (${costMappings[testId]})
                    </Tooltip>
                </span>
            </div>
        );
    }

    contents() {
        if (this.state.open) {
            return (
                <div className='accordion-contents'>
                    {this.renderOption('chemistry__acetic_acid', 'Acetic Acid')}
                    {this.renderOption('chemistry__lactic_acid', 'Lactic Acid')}
                    {this.renderOption('chemistry__sulfur_dioxide', 'Sulfur Dioxide')}
                    {this.renderOption('chemistry__free_amino_nitrogen', 'Free Amino Nitrogen')}
                    {this.renderOption('chemistry__vicinal_diketones', 'VDK')}
                    {this.renderOption('chemistry__acetaldehyde', 'Acetaldehyde')}
                    {this.renderOption('simple_nutrition__polyphenols', 'Polyphenol')}
                    {this.renderOption('simple_nutrition__starch', 'Starch')}
                </div>
            )
        }
    }

    render() {
        return (
            <div className="accordion chemistry">
                <div onClick={this.onClick}>
                    <input type='checkbox' className="user-checkbox big-checkbox" checked={this.state.open} readOnly />
                    <span className='option-label'>Chemistry <small><i> - (Click/tap to see options)</i></small>
                    </span>
                </div>
                {this.contents()}
            </div>
        );
    }
}

export default ChemistryAccordion
